import { SxProps, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { ReactElement } from 'react';

type PageHeaderProps = {
  title: ReactElement;
  subtitle?: string;
  actions?: JSX.Element;
  sx?: SxProps;
  grid?: Array<{
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  }>;
};

export default function PageHeader({
  title,
  subtitle,
  actions,
  sx = {},
  grid = [
    { xs: 9, lg: 9 },
    { xs: 3, lg: 3 },
  ],
}: PageHeaderProps) {
  return (
    <Grid2 container sx={{ mb: 2, ...sx }}>
      <Grid2 {...(grid[0] || { xs: 9 })}>
        <Typography variant="h4">{title}</Typography>
        {subtitle && (
          <Typography variant="subtitle1" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Grid2>
      {actions && (
        <Grid2 sx={{ textAlign: 'right' }} {...(grid[1] || { xs: 3 })}>
          {actions}
        </Grid2>
      )}
    </Grid2>
  );
}
